import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Menu } from 'antd';
import { useRouteMenus } from '../../../../utility/VerticalMenuUtils';
import clsx from 'clsx';
import './index.style.less';
import defaultConfig from '../../../../utility/AppContextProvider/defaultConfig';
import { useSidebarContext } from '../../../../utility/AppContextProvider/SidebarContextProvider';
import { MenuStyle } from '../../../../../shared/constants/AppEnums';

const AppVerticalNav = () => {
  const { menuStyle, sidebarColorSet }: any = useSidebarContext();
  const { pathname } = useLocation();
  const selectedKeys = pathname.substr(1).split('/');
  const defaultOpenKeys = selectedKeys[0];
  const [openKeys, setOpenKeys] = useState([defaultOpenKeys]);
  const routeMenus = useRouteMenus();

  useEffect(() => {
    setOpenKeys(selectedKeys?.slice(0, selectedKeys.length - 1));
  }, []);

  // A nested group's key is its parents' keys joined by dots
  // (e.g. 'promotions.news-letter'), so its last segment is not a key.
  const parentKeysOf = (key: string) => key.split('.').slice(0, -1);

  const onOpenChange = (keys: string[]) => {
    const openedKey = keys.find((key) => !openKeys.includes(key));
    // Closing: keep the groups that are still open, minus those whose parent closed.
    if (!openedKey) {
      setOpenKeys(
        keys.filter((key) =>
          parentKeysOf(key).every((parent) => keys.includes(parent)),
        ),
      );
      return;
    }
    // Opening: only the opened group and its parents stay open.
    setOpenKeys([...parentKeysOf(openedKey), openedKey]);
  };

  return (
    <Menu
      theme={sidebarColorSet.mode}
      mode='inline'
      className={clsx('app-main-sidebar-menu ', {
        'menu-rounded': menuStyle === MenuStyle.ROUNDED,
        'menu-rounded rounded-menu-reverse':
          menuStyle === MenuStyle.ROUNDED_REVERSE,
        'menu-rounded standard-menu': menuStyle === MenuStyle.STANDARD,
        'menu-rounded curved-menu': menuStyle === MenuStyle.CURVED_MENU,
        'bg-color-menu':
          sidebarColorSet.sidebarBgColor !==
          defaultConfig.sidebar.colorSet.sidebarBgColor,
      })}
      openKeys={openKeys}
      onOpenChange={onOpenChange}
      selectedKeys={[selectedKeys[selectedKeys.length - 1]]}
    >
      {routeMenus}
    </Menu>
  );
};

export default AppVerticalNav;
